(function () {
  'use strict';

  function localizeBadge(wrapper) {
    if (wrapper.dataset.bkRatingLocale !== 'ar') return;
    const badge = wrapper.querySelector('[data-number-of-reviews]');
    if (!badge) return;
    const count = Number.parseInt(badge.getAttribute('data-number-of-reviews') || '0', 10);
    if (!Number.isFinite(count) || count <= 0) {
      wrapper.hidden = true;
      return;
    }
    const label = count === 1 ? 'مراجعة واحدة' : `${count.toLocaleString('ar-EG')} مراجعات`;
    const text = wrapper.querySelector('.jdgm-prev-badge__text');
    if (text) text.textContent = label;
    badge.setAttribute('aria-label', label);
  }

  function scan(scope = document) {
    const wrappers = scope.matches?.('[data-bk-rating-badge]')
      ? [scope]
      : Array.from(scope.querySelectorAll?.('[data-bk-rating-badge]') || []);
    wrappers.forEach(localizeBadge);
  }

  if (window.BKSocialProof) {
    window.BKSocialProof.scan();
    return;
  }

  document.addEventListener('shopify:section:load', (event) => scan(event.target));
  window.BKSocialProof = { scan };
  scan();
})();
